import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const DashboardIcon = ({
  width = 20,
  height = 20,
  color = '#38383E',
  ...props
}: IconProps) => (
  <SvgComponent viewBox='0 0 20 20'
    width={width}
    height={height}
    {...props}
  >
    <path
      fill={color}
      d='M7.083 10.417a2.5 2.5 0 0 1 2.5 2.5v2.916a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5v-2.916a2.5 2.5 0 0 1 2.5-2.5h2.916Zm8.75 0a2.5 2.5 0 0 1 2.5 2.5v2.916a2.5 2.5 0 0 1-2.5 2.5h-2.916a2.5 2.5 0 0 1-2.5-2.5v-2.916a2.5 2.5 0 0 1 2.5-2.5h2.916Zm-8.75 1.25H4.167c-.666 0-1.21.52-1.248 1.176l-.002.074v2.916c0 .666.52 1.21 1.176 1.248l.074.002h2.916c.666 0 1.21-.52 1.248-1.176l.002-.074v-2.916c0-.666-.52-1.21-1.176-1.248l-.074-.002Zm8.75 0h-2.916c-.666 0-1.21.52-1.248 1.176l-.002.074v2.916c0 .666.52 1.21 1.176 1.248l.074.002h2.916c.666 0 1.21-.52 1.248-1.176l.002-.074v-2.916c0-.666-.52-1.21-1.176-1.248l-.074-.002Zm-8.75-10a2.5 2.5 0 0 1 2.5 2.5v2.916a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V4.167a2.5 2.5 0 0 1 2.5-2.5h2.916Zm8.75 0a2.5 2.5 0 0 1 2.5 2.5v2.916a2.5 2.5 0 0 1-2.5 2.5h-2.916a2.5 2.5 0 0 1-2.5-2.5V4.167a2.5 2.5 0 0 1 2.5-2.5h2.916Zm-8.75 1.25H4.167c-.666 0-1.21.52-1.248 1.176l-.002.074v2.916c0 .666.52 1.21 1.176 1.248l.074.002h2.916c.666 0 1.21-.52 1.248-1.176l.002-.074V4.167c0-.666-.52-1.21-1.176-1.248l-.074-.002Zm8.75 0h-2.916c-.666 0-1.21.52-1.248 1.176l-.002.074v2.916c0 .666.52 1.21 1.176 1.248l.074.002h2.916c.666 0 1.21-.52 1.248-1.176l.002-.074V4.167c0-.666-.52-1.21-1.176-1.248l-.074-.002Z'
    />
  </SvgComponent>
);

export default DashboardIcon;
